import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { type ReactElement, useEffect } from 'react';
import { FrontSidebar } from '@/front/FrontSidebar';
import { storeFrontSecret } from '@/front/frontSecret';

/**
 * Front's plugin panel. Outside the member shell and the console; on
 * `useAuthCheck`'s public list. The shared secret arrives
 * in `?auth_secret=` once, is moved into sessionStorage and leaves the URL.
 */
export const Route = createFileRoute('/front/sidebar')({
  component: FrontSidebarPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): { auth_secret?: string; handle?: string } => ({
    auth_secret:
      typeof search.auth_secret === 'string' ? search.auth_secret : undefined,
    handle: typeof search.handle === 'string' ? search.handle : undefined,
  }),
});

function FrontSidebarPage(): ReactElement | null {
  const { auth_secret, handle } = Route.useSearch();
  const navigate = useNavigate();

  // Stored during render, before FrontSidebar reads it; the navigate below
  // strips it from the URL afterwards.
  if (auth_secret) storeFrontSecret(auth_secret);

  useEffect(() => {
    if (auth_secret) {
      void navigate({
        to: '/front/sidebar/',
        search: { handle },
        replace: true,
      });
    }
  }, [auth_secret, handle, navigate]);

  return <FrontSidebar handle={handle} />;
}
